export function log<T>(message: string, data: T) {
	//todo: implement a proper logging system that sends logs to a server
	console.debug(`[WeirdCaseLogger] ${message}`, data);
}
